import React from "react";

import Modal from "@components/atoms/Modal";
import { useTranslation } from "react-i18next";
import DefaultSearchGroupScreen from "@scenes/more/searchGroup/components/DeafultSearchGroupScreen";
import { useTheme } from "styled-components/native";
import { Platform } from "react-native";
import ProductSearchGroupParentScreenWeb from "@scenes/more/searchGroup/components/ProductSearchGroupParentScreenWeb";

const DefaultSearchGroupModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={0}
      paddingRight={0}
      paddingBottom={0}
      paddingTop={16}
      headerTitle={t("navigation.profile.general.label.searchGroup")}
      backgroundColor={theme["core-01"]}
      size="md"
      enableToastMessage={true}
    >
      {Platform.OS === "web" && !theme.isMobile ? (
        <ProductSearchGroupParentScreenWeb />
      ) : (
        <DefaultSearchGroupScreen removeExtraSpacing />
      )}
    </Modal>
  );
};

export default DefaultSearchGroupModal;
